import React from 'react'
import Sidebar from '../organisms/Sidebar'
import ToolLayout from '../organisms/ToolLayout'
import { SeoHead } from '../seo/SeoHead'
import { getPageForPath } from '../seo/pages'
import './ToolPageTemplate.css'

const ToolPageTemplate = ({ children, path, tools = [], className = '', title, description, breadcrumbItems: manualBreadcrumbs, ...props }) => {
  const page = getPageForPath(path)
  const classes = ['tool-page-template', className].filter(Boolean).join(' ')

  // Use content model if available; fall back to manual props (unmigrated pages)
  const finalTitle = page?.h1 || title
  const finalDescription = page?.intro || description
  const finalBreadcrumbItems = page?.breadcrumbs || manualBreadcrumbs

  return (
    <div className={classes} {...props}>
      {path && <SeoHead path={path} />}
      <Sidebar tools={tools} />
      <ToolLayout
        title={finalTitle}
        description={finalDescription}
        breadcrumbItems={finalBreadcrumbItems}
      >
        {children}
      </ToolLayout>
    </div>
  )
}

export default ToolPageTemplate